module.exports = __webpack_public_path__ + "static/images/up-gift.185b673.png";